<div class="ai-dialog">
    <header class="dlg-head">
        <div class="dlg-titles">
            <div class="dlg-eyebrow"><i class="bi bi-robot"></i> AI Finisher</div>
            <h2 class="dlg-title">
                AI work for import #{{ data.importId }}
                @if (data.filename) { <span class="dlg-file mono">{{ data.filename }}</span> }
            </h2>
        </div>
        <button class="dlg-close" (click)="dialogRef.close()" title="Close">
            <i class="bi bi-x-lg"></i>
        </button>
    </header>

    @if (suggestions().length > 1) {
        <div class="dlg-tabs">
            @for (s of suggestions(); track s.id) {
                <button class="dlg-tab" [class.active]="selected()?.id === s.id" (click)="select(s)">
                    #{{ s.id }} · {{ s.suggestionType || 'suggestion' }}
                    <span class="tab-status">{{ s.approvalStatus || 'PENDING' }}</span>
                </button>
            }
        </div>
    }

    <div class="dlg-body">
        @if (!loading() && suggestions().length === 0) {
            <div class="dlg-empty">
                <i class="bi bi-hourglass-split"></i>
                <p>The AI worked this import but has not produced a suggestion yet — check the decision log
                    on the AI Finisher page, or come back when the run finishes.</p>
            </div>
        } @else {
            <app-ai-suggestion-detail
                [suggestion]="selected()"
                [aiWork]="aiWork()"
                [loading]="loading()"
                [busy]="busy()"
                (approve)="approveSelected()"
                (reject)="rejectSelected($event)"
                (download)="downloadSelected()">
            </app-ai-suggestion-detail>
        }
    </div>
</div>
